import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import { DEFAULT_LABEL_CONFIG } from "app/themes/components/input";
import ProductCategoryFilter, {
  ProductCategoryFilterValue
} from "components/product-category-filter";
import { ProductCategory } from "services/types/product-categories.type";

type CategoryFilterProps = {
  categories: ProductCategory[];
  value: ProductCategoryFilterValue;
  onChange: (value: ProductCategoryFilterValue) => void;
  disabled?: boolean;
};

export default function CategoryFilter({
  categories,
  value,
  onChange,
  disabled = false
}: CategoryFilterProps) {
  return (
    // inline-size containment keeps a long row of buttons from widening the
    // form it sits in; the row scrolls instead.
    <FormControl
      disabled={disabled}
      sx={{ width: "100%", minWidth: 0, contain: "inline-size" }}
    >
      <FormLabel
        id="product-category-filter"
        sx={DEFAULT_LABEL_CONFIG}
        style={{ paddingBottom: "4px" }}
      >
        Category
      </FormLabel>
      <ProductCategoryFilter
        categories={categories}
        value={value}
        onChange={onChange}
        labelledBy="product-category-filter"
        disabled={disabled}
      />
    </FormControl>
  );
}
